// Exporting to be stubbed
export function addResizeObserver(callback) {
  const observer = new ResizeObserver(callback);
  observer.observe(document.body);
}